export const SIZE_GUIDE_INTRO =
  "If you normally wear a size M in Biba or W, choose M here. Our sizing runs standard for Indian bodies — not the European sizing you'll find on some brands. We offer S through 5XL on every piece.";

export const SIZE_CHART = [
  { size: "S", bust: "32–34\"", waist: "26–28\"", hip: "34–36\"" },
  { size: "M", bust: "34–36\"", waist: "28–30\"", hip: "36–38\"" },
  { size: "L", bust: "36–38\"", waist: "30–32\"", hip: "38–40\"" },
  { size: "XL", bust: "38–40\"", waist: "32–34\"", hip: "40–42\"" },
  { size: "XXL", bust: "40–42\"", waist: "34–36\"", hip: "42–44\"" },
  { size: "3XL", bust: "42–44\"", waist: "36–38\"", hip: "44–46\"" },
  { size: "4XL", bust: "44–46\"", waist: "38–40\"", hip: "46–48\"" },
  { size: "5XL", bust: "46–48\"", waist: "40–42\"", hip: "48–50\"" },
];

export const SIZE_GUIDE_BY_CATEGORY = {
  ethnic: {
    label: "Kurtis & ethnic",
    fit: "Relaxed through the body with room for movement. If you're between sizes, size down.",
  },
  coords: {
    label: "Co-ord sets",
    fit: "Structured at the waist with a tailored finish. If you're between sizes, size up.",
  },
  dresses: {
    label: "Dresses",
    fit: "Most dresses have a fluid or bias cut. If you're between sizes, size down for a closer fit or up for ease.",
  },
  tops: {
    label: "Tops",
    fit: "True to size with a comfortable shoulder fit. If you're between sizes, choose your usual top size.",
  },
};

export const getSizeGuide = (category) =>
  SIZE_GUIDE_BY_CATEGORY[category] || {
    label: "All pieces",
    fit: "If you're between sizes, email us at oorilabel@gmail.com — we'll help you choose.",
  };

/** Garment measurements — same values as /oori-size-guide.html */
export const SIZE_CHART_DATA = {
  in: {
    label: "in",
    rows: [
      { size: "S", shoulder: "14.5", bust: "36.0", length: "35.8", waist: "26.0", inseam: "24.8", hip: "36.0", toWaist: "28.0" },
      { size: "M", shoulder: "15.0", bust: "38.0", length: "36.4", waist: "28.0", inseam: "24.8", hip: "38.0", toWaist: "30.0" },
      { size: "L", shoulder: "15.5", bust: "40.0", length: "37.0", waist: "30.0", inseam: "24.8", hip: "40.0", toWaist: "32.0" },
      { size: "XL", shoulder: "16.0", bust: "42.0", length: "37.6", waist: "32.0", inseam: "24.8", hip: "42.0", toWaist: "34.0" },
      { size: "XXL", shoulder: "16.5", bust: "44.0", length: "38.2", waist: "34.0", inseam: "24.8", hip: "44.0", toWaist: "36.0" },
      { size: "3XL", shoulder: "17.0", bust: "46.0", length: "38.8", waist: "36.0", inseam: "24.8", hip: "46.0", toWaist: "38.0" },
      { size: "4XL", shoulder: "17.5", bust: "48.0", length: "39.4", waist: "38.0", inseam: "24.8", hip: "48.0", toWaist: "40.0" },
      { size: "5XL", shoulder: "18.0", bust: "50.0", length: "40.0", waist: "40.0", inseam: "24.8", hip: "50.0", toWaist: "42.0" },
    ],
  },
  cm: {
    label: "cm",
    rows: [
      { size: "S", shoulder: "36.8", bust: "91.4", length: "90.9", waist: "66.0", inseam: "63.0", hip: "91.4", toWaist: "71.1" },
      { size: "M", shoulder: "38.1", bust: "96.5", length: "92.5", waist: "71.1", inseam: "63.0", hip: "96.5", toWaist: "76.2" },
      { size: "L", shoulder: "39.4", bust: "101.6", length: "94.0", waist: "76.2", inseam: "63.0", hip: "101.6", toWaist: "81.3" },
      { size: "XL", shoulder: "40.6", bust: "106.7", length: "95.5", waist: "81.3", inseam: "63.0", hip: "106.7", toWaist: "86.4" },
      { size: "XXL", shoulder: "41.9", bust: "111.8", length: "97.0", waist: "86.4", inseam: "63.0", hip: "111.8", toWaist: "91.4" },
      { size: "3XL", shoulder: "43.2", bust: "116.8", length: "98.6", waist: "91.4", inseam: "63.0", hip: "116.8", toWaist: "96.5" },
      { size: "4XL", shoulder: "44.5", bust: "121.9", length: "100.1", waist: "96.5", inseam: "63.0", hip: "121.9", toWaist: "101.6" },
      { size: "5XL", shoulder: "45.7", bust: "127.0", length: "101.6", waist: "101.6", inseam: "63.0", hip: "127.0", toWaist: "106.7" },
    ],
  },
};
